import { RESET_PASSWORD_ERROR, RESET_PASSWORD_SUCCESS } from 'actions';
import { ResetPasswordActionTypes } from 'actionsConstants';
import { hitApi, ObservableAjax } from '__common/utils/api';
import { safeOfType as ofType } from '__common/utils/safeOfType';
import { switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

export function resetPassword(action$: Observable<any>) {
  return action$.pipe(
    ofType(ResetPasswordActionTypes.RESET_PASSWORD),
    switchMap(action =>
      ObservableAjax({
        until$: action$.pipe(ofType(ResetPasswordActionTypes.RESET_PASSWORD)),
        onSuccess: RESET_PASSWORD_SUCCESS,
        onError: RESET_PASSWORD_ERROR,
        onErrorMessage: 'Cannot reset password',
        link: hitApi('put', 'api/auth/deactivate/'),
      }),
    )
  );
}
